"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAuthWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Errors = require("./Errors");
var _excluded = ["authProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// Takes user to forbidden page if the isAuthorized function returns false
var UserAuthWrapper = exports.UserAuthWrapper = function UserAuthWrapper(_ref) {
  var authSelector = _ref.authSelector,
    isAuthorized = _ref.isAuthorized;
  return function (WrappedComponent) {
    var AuthenticatedComponent = function AuthenticatedComponent(_ref2) {
      var authProps = _ref2.authProps,
        props = _objectWithoutProperties(_ref2, _excluded);
      if (isAuthorized(authProps)) {
        // ****************************************************************
        //   NOTE:
        //   AppSec logging should be handled by the consumer
        //   of this HOC as they would be able to identify the required
        //   data fields.
        // ****************************************************************
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, props);
      }
      return /*#__PURE__*/_react.default.createElement(_Errors.Forbidden, null);
    };
    AuthenticatedComponent.readyOnActions = WrappedComponent.readyOnActions;
    AuthenticatedComponent.isAuthorized = function (state) {
      return isAuthorized(authSelector(state));
    };
    return (0, _reactRedux.connect)(function (state, ownProps) {
      return {
        authProps: authSelector(state, ownProps)
      };
    })(AuthenticatedComponent);
  };
};